import type { Element } from "React";
import "./IconGbFlag.scss";
type Props = {
  className?: string;
};

const IconGbFlag = (props: Props): Element<"svg"> => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className="asian-icon"
  >
    <defs>
      <rect id="a" width="16" height="16" rx="8" />
      <rect id="c" width="22.4" height="16" rx="2" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="b" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <use fill="#00247D" xlinkHref="#a" />
      <g mask="url(#b)">
        <g transform="translate(-3.2)">
          <mask id="d" fill="#fff">
            <use xlinkHref="#c" />
          </mask>
          <use fill="#FFF" xlinkHref="#c" />
          <path fill="#0A17A7" d="M0 0h22.4v16H0z" mask="url(#d)" />
          <path
            fill="#FFF"
            d="M5.339 10.667H0V5.333h5.339L-2.219.235l1.193-1.768 9.56 6.448v-5.982h5.333v5.982l9.559-6.448L24.619.235 17.06 5.333H22.4v5.334h-5.339l7.558 5.098-1.193 1.768-9.56-6.448v5.982H8.534v-5.982l-9.559 6.448-1.193-1.768 7.558-5.098z"
            mask="url(#d)"
          />
          <path
            stroke="#DB1F35"
            strokeLinecap="round"
            strokeWidth=".667"
            d="M14.934 5.066L25.067-1.6"
            mask="url(#d)"
          />
          <path
            stroke="#DB1F35"
            strokeLinecap="round"
            strokeWidth=".667"
            d="M16.01 17.08l9.083-6.122"
            mask="url(#d)"
            transform="matrix(1 0 0 -1 0 28.038)"
          />
          <path
            stroke="#DB1F35"
            strokeLinecap="round"
            strokeWidth=".667"
            d="M6.404 5.048L-3.07-1.337"
            mask="url(#d)"
          />
          <path
            stroke="#DB1F35"
            strokeLinecap="round"
            strokeWidth=".667"
            d="M7.432 17.848L-3.07 10.884"
            mask="url(#d)"
            transform="matrix(1 0 0 -1 0 28.732)"
          />
          <path
            fill="#E6273E"
            d="M0 9.6h9.6V16h3.2V9.6h9.6V6.4h-9.6V0H9.6v6.4H0z"
            mask="url(#d)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default IconGbFlag;
